import React, { useCallback } from 'react';

import { useSmallScreen } from 'utils/hooks';
import { parseSum } from 'utils/helpers';
import { texts } from 'utils/languages/fr';

import { ActionButton, CancelButton, CustomDialogTitle, StyledTableRow } from 'components';
import {
    DialogContent,
    DialogActions,
    Dialog,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    dialogContent: {
        padding: theme.spacing(2, 3),
        color: theme.palette.grey[600],
        display: 'flex',
        width: '100%',
    },
}));

const tableHeads = [
    { id: 'lastName', isSortable: false, label: texts.NOM },
    { id: 'fundName', isSortable: false, label: texts.FUND },
    { id: 'firstInstalmentAmount', isSortable: false, label: texts.MONTANT_PRELEVEMENT },
    { id: 'debitDate', isSortable: false, label: texts.FIRST_DEBIT_DATE },
];

const DebitsPreviewDialog = ({ open, onClose, onValidate, loading, payments }) => {
    const classes = useStyles();
    const fullScreen = useSmallScreen();

    const renderRow = useCallback(
        ({ id, amount, recipientName, paymentTransferDate, fundName }) => (
            <StyledTableRow key={id}>
                <TableCell>{recipientName}</TableCell>
                <TableCell>{fundName || ''}</TableCell>
                <TableCell>{parseSum(amount)}</TableCell>
                <TableCell>{paymentTransferDate?.format('L') || ''}</TableCell>
            </StyledTableRow>
        ),
        []
    );

    return (
        <Dialog fullScreen={fullScreen} open={open}>
            <CustomDialogTitle title={texts.PAYMENTS_EXECUTION} handleClose={onClose} />
            <DialogContent className={classes.dialogContent}>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {tableHeads.map(th => (
                                    <TableCell key={th.id}>{th.label}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {payments.filter(i => !i.isCheckboxDisabled).map(renderRow)}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <CancelButton disabled={loading} onClick={onClose}>
                    {texts.CANCEL}
                </CancelButton>
                <ActionButton loading={loading} disabled={loading} onClick={onValidate}>
                    {texts.VALIDER}
                </ActionButton>
            </DialogActions>
        </Dialog>
    );
};

export default DebitsPreviewDialog;
